/// <reference lib="dom" />

import { useGetAllContents } from '@/hooks/useGetAllContents';
import { extractHostname } from '@/utils/urlUtils';

export const useContentAnalytics = () => {
  const { contents } = useGetAllContents();

  const total = contents.length;

  const langs = [...new Set(contents.map(c => c.lang))];
  const sources = [...new Set(contents.map(c => extractHostname(c.source)))];

  const langCounts = contents.reduce<Record<string, number>>((acc, { lang }) => {
    acc[lang] = (acc[lang] || 0) + 1;
    return acc;
  }, {});

  const timelineCounts = contents.reduce<Record<string, number>>((acc, { date }) => {
    const formatted = new Date(date).toLocaleDateString();
    acc[formatted] = (acc[formatted] || 0) + 1;
    return acc;
  }, {});

  return {
    total,
    langsCount: langs.length,
    sourcesCount: sources.length,
    langCounts,
    timelineCounts,
  };
};
